import React from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  background-color: #000;
  color: #fff;
  padding: 13px 19px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: Raleway, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  max-width: 466px;
`;

const IconWrapper = styled.div`
  width: 26px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font-family: ralewayBold;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
`;

interface InfoBannerProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  testId?: string;
}

export const InfoBanner: React.FC<InfoBannerProps> = ({
  icon,
  title,
  subtitle,
  testId = 'info-banner'
}) => {
  return (
    <Banner data-testid={testId}>
      <IconWrapper>{icon}</IconWrapper>
      <BannerText>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </BannerText>
    </Banner>
  );
};
